<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput placeholder="Username" v-model="$v.LoginForm.email.$model" autocomplete="username email">
                    <template #prepend-content>
                      <CIcon name="cil-user" />
                    </template>
                  </CInput>
                  <CInput placeholder="Password" v-model="$v.LoginForm.password.$model" type="password" autocomplete="curent-password">
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked" />
                    </template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4"  @click="submitLogin" :disabled="$v.LoginForm.$invalid">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0">Forgot password?</CButton>
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <!-- <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Register Now!
                </CButton>-->
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "ForgotPassword",
  data() {
    return {
      LoginForm: {
        email: null,
        password: null
      }
    };
  },
  validations: {
    LoginForm: {
      email: { required },
      password: { required }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  watch: {
    storage(data) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user_code", data.user_code);
    }
  },
  methods: {
    init: function() {},
    submitLogin: function() {
      console.log(this.LoginForm);
      this.axios.post("/auth/login-console", this.LoginForm).then(response => {
          if (response.data.status === 2000) {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("user_code", response.data.user.user_code);
            localStorage.setItem("email", response.data.user.email);
            localStorage.setItem("token_uid", response.data.user['token-uid']);
            localStorage.setItem("is_agent", response.data.user.agent);
            // localStorage.setItem('nik', response.data.nik)
            // localStorage.setItem('employee_id', response.data.employee_id)
            // localStorage.setItem('name', response.data.name)
            // localStorage.setItem('division_id', response.data.division_id)
            // localStorage.setItem('position_id', response.data.position_id)
            // localStorage.setItem('division_name', response.data.division_name)
            // localStorage.setItem('position_name', response.data.position_name)
            // localStorage.setItem('start_page', response.data.start_page)
            // localStorage.setItem('level', response.data.level)
            this.showInfoNotification({
              title: "Login",
              message: response.data.message
            });

            this.handleSubmit();
          } else {
            this.showErrorNotification({
              title: "Login",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          //console.log(error)
          this.showErrorNotification({
            title: "Login",
            message: error.response.message
          });
        });
    },
    handleSubmit: function() {
      this.$router.push({ path: "dashboard" });
    }
  }
};
</script>
